import React, {useState} from 'react';
import {Card} from "../../components/Card";
import {createInternationalizationPrefixer} from "../../platform/i18n/i18n";
import AjaxService from "../../platform/ajax/AjaxService";

const t = createInternationalizationPrefixer("TestEmailPage");

type TrialResult = {
    success: boolean,
    message: string,
};

function LabeledInput(props: {
    label: string,
    value: string,
    onChange: (value: string) => void,
    type?: string,
    placeholder?: string,
}) {
    return <div className={"mb-3"}>
        <label className={"form-label"}>{props.label}</label>
        <input
            className={"form-control"}
            type={props.type || "text"}
            value={props.value}
            placeholder={props.placeholder}
            onChange={(e) => props.onChange(e.target.value)}/>
    </div>;
}

function LabeledCheckbox(props: { label: string, checked: boolean, onChange: (checked: boolean) => void }) {
    return <div className={"form-check mb-3"}>
        <input
            className={"form-check-input"}
            type={"checkbox"}
            checked={props.checked}
            onChange={(e) => props.onChange(e.target.checked)}/>
        <label className={"form-check-label"}>{props.label}</label>
    </div>;
}

function ResultPanel(props: { result: TrialResult }) {
    const alertClass = props.result.success ? "alert-success" : "alert-danger";
    return <div className={"alert " + alertClass + " mt-3"}>
        <pre className={"mb-0"} style={{whiteSpace: "pre-wrap"}}>{props.result.message}</pre>
    </div>;
}

export function SmtpTrialForm() {
    const [host, setHost] = useState("");
    const [port, setPort] = useState("587");
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [fromAddress, setFromAddress] = useState("");
    const [toEmail, setToEmail] = useState("");
    const [subject, setSubject] = useState("Optisel - test SMTP");
    const [body, setBody] = useState("<h1>Test SMTP</h1>");
    const [startTls, setStartTls] = useState(true);
    const [auth, setAuth] = useState(true);
    const [sending, setSending] = useState(false);
    const [result, setResult] = useState<TrialResult | null>(null);

    const submit = async () => {
        setSending(true);
        setResult(null);
        const request = {
            host, port: Number(port), username, password,
            startTls, auth, fromAddress, toEmail, subject, body,
        };
        try {
            const response = await AjaxService.postJson("/api/admin/test-email/smtp-trial", request);
            setResult(response.json as TrialResult);
        } finally {
            setSending(false);
        }
    };

    return <Card header={t("Test dowolnego serwera SMTP")} additionalClassNames={"mt-4"}>
        <LabeledInput label={t("Serwer (host)")} value={host} onChange={setHost} placeholder={"smtp.example.com"}/>
        <LabeledInput label={t("Port")} value={port} onChange={setPort} type={"number"}/>
        <LabeledInput label={t("Użytkownik")} value={username} onChange={setUsername}/>
        <LabeledInput label={t("Hasło")} value={password} onChange={setPassword} type={"password"}/>
        <LabeledInput label={t("Adres nadawcy (from)")} value={fromAddress} onChange={setFromAddress} placeholder={"no-reply@example.com"}/>
        <LabeledInput label={t("Adres docelowy")} value={toEmail} onChange={setToEmail} placeholder={"odbiorca@example.com"}/>
        <LabeledInput label={t("Temat")} value={subject} onChange={setSubject}/>
        <div className={"mb-3"}>
            <label className={"form-label"}>{t("Treść (HTML)")}</label>
            <textarea className={"form-control"} rows={4} value={body} onChange={(e) => setBody(e.target.value)}/>
        </div>
        <LabeledCheckbox label={t("STARTTLS")} checked={startTls} onChange={setStartTls}/>
        <LabeledCheckbox label={t("Uwierzytelnianie (auth)")} checked={auth} onChange={setAuth}/>
        <button className={"btn btn-primary"} disabled={sending} onClick={submit}>
            {sending ? t("Wysyłanie...") : t("Wyślij przez ten serwer")}
        </button>
        {result && <ResultPanel result={result}/>}
    </Card>;
}
